//File is ignored by Git
export const magicImport = (refComponent: string) => {
  return () =>
    import(
      /* Payback: Insert asb_modules\/payback\/ for asb_modules\/syngenio\/ */
      /* webpackInclude: /((core\/|components\/|asb_modules\/syngenio\/)(?!.*(\.test\.tsx|setupTests\.ts|\.stories\.(js|mdx)|\.snap).*))/ */
      `../../${refComponent}`
    ).catch((e) => {
      console.error(e?.message ?? 'Component load error');
    });
};
